export const MIN_SEARCH_LEN = 2
export const AUTOCOMPLETE_ITEM_HEIGHT = 56
